/* eslint-disable no-shadow */
import { getIdentifierName } from './service-identifier';
let _enableTracing = false;
// 开启依赖注入初始化日志
export function enableInstantiationTrace() {
    _enableTracing = true;
}
// 关闭依赖注入实例化日志
export function disableInstantiationTrace() {
    _enableTracing = false;
}
/**
 * 用于依赖注入框架注入模块时的日志跟踪，对日常开发调试非常有用
 */
export class InstantiationTrace {
    constructor(type, name) {
        this.type = type;
        this.name = name;
        this._start = Date.now();
        this._dep = [];
    }
    /**
     * 跟踪依赖注入框架的invoke调用
     * @param ctor 构造函数
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    static traceInvocation(ctor) {
        return !_enableTracing
            ? InstantiationTrace._None
            : new InstantiationTrace(1 /* Invocation */, ctor.name || ctor.toString().substring(0, 42).replace(/\n/g, ''));
    }
    /**
     * 跟踪依赖注入框架的create调用
     * @param ctor 构造函数
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    static traceCreation(ctor) {
        return !_enableTracing
            ? InstantiationTrace._None
            : new InstantiationTrace(0 /* Creation */, ctor.name);
    }
    /**
     * 遍历日志，生成层级化结构
     * @param trace 日志对象
     * @param serviceId 服务ID
     * @param created 是否为create调用
    */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    static traverse(trace, serviceId, created = false) {
        if (!_enableTracing) {
            return created;
        }
        let isCreated = created;
        // 遍历trace日志的依赖关系
        trace === null || trace === void 0 ? void 0 : trace._dep.forEach((depItem, idx) => {
            const [id, first, child] = depItem;
            if (id === serviceId) {
                if (isCreated === true && first === true) {
                    trace._dep[idx] = [
                        id,
                        false,
                        new InstantiationTrace(2 /* Branch */, id.toString()),
                    ];
                }
                else {
                    isCreated = true;
                    if ((child === null || child === void 0 ? void 0 : child._dep) && (child === null || child === void 0 ? void 0 : child._dep.length) > 0) {
                        isCreated = InstantiationTrace.traverse(child, serviceId, isCreated);
                    }
                }
            }
            else if ((child === null || child === void 0 ? void 0 : child._dep) && (child === null || child === void 0 ? void 0 : child._dep.length) > 0) {
                isCreated = InstantiationTrace.traverse(child, serviceId, isCreated);
            }
        });
        return isCreated;
    }
    /**
     * 新建一层日志Trace，组成树形结构
     * @param id
     * @param first
     */
    branch(id, first) {
        const child = new InstantiationTrace(2 /* Branch */, id.toString());
        this._dep.push([id, first, child]);
        return child;
    }
    // 结束日志的trace过程，输出日志
    stop() {
        const dur = Date.now() - this._start;
        InstantiationTrace._totals += dur;
        let causedCreation = false;
        // 递归遍历日志树，使用\t符输出层级结构
        function printChild(n, trace) {
            const res = [];
            const prefix = new Array(n + 1).join('\t');
            for (const [id, first, child] of trace._dep) {
                if (first && child) {
                    causedCreation = true;
                    res.push(`${prefix}CREATES -> ${getIdentifierName(id)}`);
                    const nested = printChild(n + 1, child);
                    if (nested) {
                        res.push(nested);
                    }
                }
                else {
                    res.push(`${prefix}uses -> ${getIdentifierName(id)}`);
                }
            }
            return res.join('\n');
        }
        const lines = [
            `${this.type === 0 /* Creation */ ? 'CREATE' : 'CALL'} ${this.name}`,
            `${printChild(1, this)}`,
            `DONE, took ${dur.toFixed(2)}ms (grand total ${InstantiationTrace._totals.toFixed(2)}ms)`,
        ];
        if (dur > 2 || causedCreation) {
            console.log(lines.join('\n'));
        }
    }
}
InstantiationTrace._None = new (class extends InstantiationTrace {
    constructor() {
        super(-1, null);
    }
    stop() { }
    branch() {
        return this;
    }
})();
InstantiationTrace._totals = 0;
//# sourceMappingURL=instantiation-trace.js.map